import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "./slices/counterSlice";
import layoutReducer from "./slices/layoutSlice";
import domainReducer from "./slices/domainSlice";
import authReducer from './slices/authSlice'
import subscriptionReducer from './slices/subscriptionSlice'
import uiReducer from './slices/uiSlice'
import themeConfigSlice from './slices/themeConfigSlice';
import permissionReducer from './slices/permissionSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    layout: layoutReducer,
    domain: domainReducer,
    auth: authReducer,
    ui:uiReducer,
    themeConfig: themeConfigSlice,
    subscription: subscriptionReducer,
    permission: permissionReducer,
  },
});

// Infer types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
